/* eslint-disable react/prop-types */
// External deps
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Internal deps
import { Table } from 'ypf-pas-general-ui-components';

import { formDateHour } from '../../../../utils/formatUtils';
import { sortByCant, sortByDate } from '../TotalLineOverviewTable/TotalLineOverviewTable';

const getColumns = (currency) => [
  {
    Header: 'Fecha',
    accessor: 'fecha'
  },
  {
    Header: 'Cant. Reg.',
    accessor: 'cantReg',
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: 'Cant. Cert.',
    accessor: 'cantCert',
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: `Tarifa (${currency})`,
    accessor: 'tarifa',
    hideSort: true,
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: `PxQ (${currency})`,
    accessor: 'pxQ',
    hideSort: true,
    style: {
      fontWeight: '600',
      textAlign: 'right'
    },
    Cell: (cell) => {
      const { row } = cell;

      return (
        <div
          style={{
            marginRight: '20px'
          }}
        >
          {row.values.pxQ}
        </div>
      );
    }
  },
  {
    Header: 'Estado',
    accessor: 'estado',
    hideSort: true
  },
  {
    Header: 'Inspector',
    accessor: 'inspector',
    hideSort: true
  }
];

const formatColor = (color) => {
  const arr = color.split(',');

  if (arr[1]?.toLowerCase() === '#ffffff') return '#000000';
  if (arr[1]?.toLowerCase() === '#159ad8') return '#3865b8';

  return arr[1];
};

// Receives the cantReg or cantCert and return its number value, because comes as string "99 DIA" for example
// Examples: extractNumberOfCant("22,000 T/K") => Returns 22 as number. Other: extractNumberOfCant("22.412,050 T/K") => returns 22412.05 as number
const extractNumberOfCant = (cant) => Number(cant.split(' ')[0].replace('.', '').replace(',', '.'));

const formatDailyWorkReports = (dailyWorkReports) =>
  dailyWorkReports?.map((workReport) => ({
    ...workReport,
    fecha: formDateHour(workReport.fecha).newDate,
    cantidad: (
      <span
        style={{
          color: formatColor(workReport.color),
          margin: 0
        }}
      >
        {workReport.cantidad}
      </span>
    )
  }));

const TotalLineTable = ({ dailyWorkReports, serviceRequestCurrency }) => {
  const [data, setData] = useState(dailyWorkReports);

  const sortData = ({ sortBy }) => {
    const columnToSort = sortBy[0]?.id;
    const descendantSort = sortBy[0]?.desc;
    const newData = [...data];

    newData.sort((firstWR, secondWR) => {
      switch (columnToSort) {
        case 'fecha':
          return sortByDate(firstWR, secondWR, descendantSort);
        case 'cantReg':
        case 'cantCert':
          return sortByCant(firstWR, secondWR, descendantSort, columnToSort);
        default:
          return 0;
      }
    });
    setData(newData);
  };

  useEffect(() => {
    setData(dailyWorkReports);
  }, [dailyWorkReports]);

  return (
    <Table
      columns={getColumns(serviceRequestCurrency)}
      data={formatDailyWorkReports(data) || []}
      fetchData={sortData}
      initialState={{
        sortBy: [
          {
            id: '',
            desc: null
          }
        ]
      }}
      sortOrder
      titleLeft
    />
  );
};

export default TotalLineTable;

TotalLineTable.propTypes = {
  dailyWorkReports: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      fecha: PropTypes.string,
      cantidad: PropTypes.number,
      um: PropTypes.string,
      estado: PropTypes.string,
      color: PropTypes.string
    })
  ),
  serviceRequestCurrency: PropTypes.string
};

TotalLineTable.defaultProps = {
  dailyWorkReports: [],
  serviceRequestCurrency: ''
};
